import React, { Fragment, useEffect, useRef, useState } from "react"
import { toast } from "react-toastify"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"

import {
  Button,
  ConfirmationModal,
  OrderStockValidationResultModal
} from "components"
import { pay } from "services"
import { moment, validateOrderContents } from "utils"

const OrderDetailsConfirmPaymentButton = props => {
  const {
    order,
    setOrders,
    setOpenOrderDetailsSidebar
  } = props

  const [t] = useTranslation()

  const shiftCashier =
    useSelector(state => state.shiftCashier)

  const accountId =
    useSelector(state => state.userAccountInfo._id)

  const [sending, setSending] = useState(false)
  const [problematicItems, setProblematicItems] = useState([])
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false)
  const [openOrderValidationResultModal, setOpenOrderValidationResultModal] = useState(false)

  const unmount = useRef(false)

  const validateOrder = async () => {
    const problematicItems =
      await validateOrderContents(
        order.items,
        order.branchId
      )

    if (problematicItems.length === 0) return true

    setProblematicItems(
      problematicItems
    )

    setSending(false)

    setOpenOrderValidationResultModal(true)

    return false
  }

  const handleConfirmPayment = async () => {
    setSending(true)

    try {
      const result = await validateOrder()

      if (!result) return

      const shiftId =
        shiftCashier[accountId]._id

      await pay(
        {
          type: "cash",
          shiftId,
          orderIds: [order._id],
          paymentAttachUrls: order.paymentAttachUrls,
          cashType: [{
            type: "کارت بانکی",
            amount: order.totalBillAmount
          }]
        },
        { accountId: order.accountId }
      )

      if (unmount.current) return

      setOrders(prev =>
        prev.map(o =>
          o._id === order._id
            ?
            {
              ...o,
              isPaymentProblematic: false,
              paymentDate: moment().toISOString(),
              orderStatus: "paid"
            }
            : o
        )
      )

      setOpenOrderDetailsSidebar(false)

      toast.success(t("پرداخت_سفارش_تایید_شد"))
    } catch (err) {
      console.log(err)

      toast.error(t("تایید_پرداخت_انجام_نشد"))

      if (unmount.current) return

      setSending(false)
    }
  }

  useEffect(() => {
    unmount.current = false

    return () => { unmount.current = true }
  }, [])

  return (
    <Fragment>
      <Button
        fullWidth
        color="success"
        onClick={() => setOpenConfirmationModal(true)}
      >
        {t("تایید_پرداخت")}
      </Button>

      <ConfirmationModal
        title={t("آیا_می_خواهید_پرداخت_این_سفارش_را_تایید_کنید")}
        show={openConfirmationModal}
        onConfirm={handleConfirmPayment}
        onHide={() => setOpenConfirmationModal(false)}
        loading={sending}
      />

      <OrderStockValidationResultModal
        problematicItems={problematicItems}
        openOrderValidationResultModal={openOrderValidationResultModal}
        setOpenOrderValidationResultModal={setOpenOrderValidationResultModal}
      />
    </Fragment>
  )
}

export default OrderDetailsConfirmPaymentButton